import { render } from "./ExclamationFilledIcon.vue?vue&type=template&id=c2a9154c"
import script from "./ExclamationFilledIcon.vue?vue&type=script&lang=js"
export * from "./ExclamationFilledIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__